import React, { FC, ReactElement } from "react";
import styled from "styled-components";
import { myPageContentFullWrap } from "styles/CommonStyles";

interface Props {
  bottom?: number;
  children: ReactElement;
}

const FixedFooterWrap: FC<Props> = ({ bottom, children }) => (
  <Layout id="fixed-footer" dataBottom={bottom}>
    {children}
  </Layout>
);

const Layout = styled.div<{ dataBottom?: number }>`
  ${myPageContentFullWrap};
  background-color: var(--pri-bg-clr10);
  border-top: 1px solid var(--box-bdr-clr);
  padding: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: var(--title-clr);
  position: fixed;
  left: 50%;
  bottom: ${({ dataBottom }) => (dataBottom ? `${dataBottom}px` : 0)};
  transform: translateX(-50%);
  z-index: 11;
`;

export default FixedFooterWrap;
